/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachLinkIcon20Light = forwardRef('AttachLinkIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M1 9.5A5.5 5.5 0 0 1 6.5 4h1.25a.5.5 0 0 1 0 1H6.5a4.5 4.5 0 0 0 0 9h1.25a.5.5 0 0 1 0 1H6.5A5.5 5.5 0 0 1 1 9.5Z" }),
        React.createElement("path", { d: "M19 9.5A5.5 5.5 0 0 0 13.5 4h-1.25a.5.5 0 0 0 0 1h1.25a4.5 4.5 0 1 1 0 9h-1.25a.5.5 0 0 0 0 1h1.25A5.5 5.5 0 0 0 19 9.5Z" }),
        React.createElement("path", { d: "M6 9a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1H6Z" })));
});
